import { useNavigate } from "react-router-dom";
import { Image } from "../shared/index";
import styles from "./featuredbanner.module.css";

const FeaturedBanner = () => {
  const navigate = useNavigate();

  return (
    <section className={styles.featuredbanner__wrapper}>
      <div className={styles.image_container}>
        {/* First Banner */}
        <div className={styles.banner_card}>
          <Image
            src={"/assets/img/collections/vitauraimage3.png"}
            alt="Nutrition"
            className={styles.image}
          />

          <div className={styles.overlay}>
            <span className={styles.tag}>Nutrition & Wellness</span>

            <h2 className={styles.title}>
            Your   Healthy Living
              <br />
              Starts Here
            </h2>

            <p className={styles.description}>
              Discover premium nutrition supplements, wellness essentials,
              vitamins, and health products  support your everyday
              lifestyle.
            </p>

            <button
              className={styles.shopButton}
              onClick={() => navigate("/shop")}
            >
              Shop Now
            </button>
          </div>
        </div>

        {/* Second Banner */}
        <div className={styles.banner_card}>
          <Image
            src={"/assets/img/collections/vitauraimage2.png"}
            alt="Wellness"
            className={styles.image}
          />

          <div className={styles.overlay}>
            <span className={styles.tag}>Healthy Living</span>

            <h2 className={styles.title}>
              Your Daily Wellness
              <br />
              Starts Here
            </h2>

            <p className={styles.description}>
              Explore trusted health solutions for immunity, fitness, nutrition,
              and overall well-being—all in one place.
            </p>

            <button
              className={styles.shopButton}
              onClick={() => navigate("/shop")}
            >
              Shop Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedBanner;